import React from "react";

const Loader = () => {
  return (
    <div id="loader">
      <figure style={{ height: "100%" }}>
        <p>
          100<span>%</span>
        </p>
      </figure>
    </div>
  );
};

export default Loader;